import { Base64func } from "../../components/Base64Func/Base64func";
import { makeApiCall } from "../makeApiCall";
import { AdminService_URL, ThirdPartyService_URL } from "../Url";

export const dispatchActions = {
  GENERATE_AWB_STICKER_SUCCESS: "GENERATE_AWB_STICKER_SUCCESS",
  GENERATE_AWB_STICKER_FAILURE: "GENERATE_AWB_STICKER_FAILURE",
  GENERATE_PAYMENT_PENDING_PDF_SUCCESS: "GENERATE_PAYMENT_PENDING_PDF_SUCCESS",
  GENERATE_PAYMENT_PENDING_PDF_FAILURE: "GENERATE_PAYMENT_PENDING_PDF_FAILURE",
  PRINT_PDF_SUCCESS: "PRINT_PDF_SUCCESS",
  PRINT_PDF_FAILURE: "PRINT_PDF_FAILURE",
  CALL_CREATE_ORDER_API_SUCCESS: "CALL_CREATE_ORDER_API_SUCCESS",
  CALL_CREATE_ORDER_API_FAILURE: "CALL_CREATE_ORDER_API_FAILURE",
  CALL_SR_CREATE_ORDER_API_SUCCESS: "CALL_SR_CREATE_ORDER_API_SUCCESS",
  CALL_SR_SERVICEABILITY_API_FAILURE: "CALL_SR_SERVICEABILITY_API_FAILURE",
};

// action to generate awb sticker

export function generateAwbNbrStickerSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: dispatchActions.GENERATE_AWB_STICKER_SUCCESS,
      payload: props,
    });
  };
}

export function generateAwbNbrStickerError(error) {
  return {
    type: dispatchActions.GENERATE_AWB_STICKER_FAILURE,
    payload: error,
  };
}

export function generateAwbNbrStickerThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/generateAwbNbrSticker?orderId=${props.orderId}`;
  return makeApiCall(
    getUrl,
    generateAwbNbrStickerSuccess,
    generateAwbNbrStickerError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

// action to generate payment pending pdf

export function generatePaymentPendingPdfSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: dispatchActions.GENERATE_PAYMENT_PENDING_PDF_SUCCESS,
      payload: props,
    });
  };
}

export function generatePaymentPendingPdfError(error) {
  return {
    type: dispatchActions.GENERATE_PAYMENT_PENDING_PDF_FAILURE,
    payload: error,
  };
}

export function generatePaymentPendingPdfThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${ThirdPartyService_URL}/generatePaymentPendingPdf?orderId=${props.orderId}`;
  return makeApiCall(
    getUrl,
    generatePaymentPendingPdfSuccess,
    generatePaymentPendingPdfError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

// action to generate awb sticker

export function printPdfSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: dispatchActions.PRINT_PDF_SUCCESS,
      payload: props,
    });
  };
}

export function printPdfError(error) {
  return {
    type: dispatchActions.PRINT_PDF_FAILURE,
    payload: error,
  };
}

export function printPdfThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization:
      "Basic " +
      Base64func("NvmrQ1-X2Thlf1Zy5jXOz4KdkHTWQVJ2r6nzLIzrFlw:", "encode"),
  };
  const postUrl = `https://api.printnode.com/printjobs`;
  return makeApiCall(
    postUrl,
    printPdfSuccess,
    printPdfError,
    "POST",
    props.printerDetails,
    reqHeader,
    props.history
  );
}

export function createOrderSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: dispatchActions.CALL_CREATE_ORDER_API_SUCCESS,
      payload: props,
    });
  };
}

export function createOrderFailure(error) {
  return {
    type: dispatchActions.CALL_CREATE_ORDER_API_FAILURE,
    payload: error,
  };
}

// action to create order (clickpost)
export function createOrderClickPostThunk(props) {
  const postUrl = `${ThirdPartyService_URL}/createOrderCp`;
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  return makeApiCall(
    postUrl,
    createOrderSuccess,
    createOrderFailure,
    "POST",
    props.createOrderReq,
    reqHeader
  );
}

export function callSrCreateOrderAPISuccess(props) {
  return (dispatch) => {
    dispatch({
      type: dispatchActions.CALL_SR_CREATE_ORDER_API_SUCCESS,
      payload: props,
    });
  };
}

export function callSrCreateOrderAPIFailure(error) {
  return {
    type: dispatchActions.CALL_SR_SERVICEABILITY_API_FAILURE,
    payload: error,
  };
}

// action to create order (shiprocket)
export function callSrCreateOrderThunk(props) {
  // const postUrl = `${ThirdPartyService_URL}/callSrCreateOrderAPI`;
  const postUrl = `${ThirdPartyService_URL}/callSrWrapperCreateOrderAPI`;
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  return makeApiCall(
    postUrl,
    callSrCreateOrderAPISuccess,
    callSrCreateOrderAPIFailure,
    "POST",
    props.createOrderReq,
    reqHeader
  );
}
